// extracted by mini-css-extract-plugin
export default {"wrapper":"social-module--wrapper--43e7d","link":"social-module--link--31d4f"};